import React from 'react'
import {findDOMNode} from 'react-dom'
import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import NavigationMenu_ProjectsTree from "./tree/projects-tree"
import {BUS_TREE_CHANGE, SESSION_STARRED_CHANGED} from "../../../../core/gd/bus/bus-event-type"
import NavigationMenu_StarredProjects from "../../components/starred/starred-projects"
import NavigationMenu_TopHeader from "../../components/top-header/top-header";
import NavigationMenuSection from "../../menu-items/section/section"
import NavigationMenu_SpacePreferences from "../../components/space-preferences/preferences"
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {MenuComponentProps} from "../const"
import spacePreferences_PopoverMenuOptions from "../../actions/space-preferences-menu-options"
import {UIType} from "../../../ui/@const"

export default class NavigationMenu_ProjectsCustomer extends React.Component<MenuComponentProps> {

    private animationDelay  : any
    private animShow        : boolean = false

    public localSettings : NavigationMenu_ProjectsLocalSettings
    public companyUpdating? : boolean

    constructor(props:any) {
        super(props);

        this.localSettings = new NavigationMenu_ProjectsLocalSettings()
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.sessionDataChanged);

        // need it on this level as we separate stars and all projects
        gd.bus.subscribe(SESSION_STARRED_CHANGED, this, this.sessionDataChanged)

        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = findDOMNode(this);
            gd.utils.Dom.addClass(dom, 'anim-show');
        }, 50);
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
        gd.bus.unsubscribe(this)
    }

    sessionDataChanged = () => {
        this.setState({ reRender: true })
    }

    preventClosePopover() {
        const res = this.companyUpdating;
        this.companyUpdating = false;
        return res;
    }

    reRender = ()=> {
        this.forceUpdate()
    }

    render() {

        const classes = Classes("main-menu-container ui5-menu menu-projects", {
            'animation'     : gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show'     : this.animShow
        })

        const controls = (
            <NavigationMenu_SpacePreferences
                className       = "m-r-5"
                space           = {gd.spaces.projects}
                localSettings   = {this.localSettings}
                onReset         = {this.reRender}
            />
        )

        const displayResourcesHeader = (gd.layout.type !== UIType.ASANA)

        return (
            <div className={classes}>

                <NavigationMenu_TopHeader space = {gd.spaces.projects}/>

                <VScroll
                    ref                     = {this.props.refScroll}
                    className               = "main-menu-scroll"
                    mutationObserverEnabled = {true}
                >

                    <NavigationMenu_StarredProjects
                        systemName  = "projects-starred"
                        space       = {gd.spaces.projects}
                    />

                    {displayResourcesHeader &&
                        <NavigationMenuSection
                            name        = "Resources"
                            collapsible = {true}
                            menuOptions = {spacePreferences_PopoverMenuOptions(gd.spaces.projects, this.localSettings, this.reRender)}
                            controls    = {controls}
                            systemName  = "projects-resources"
                            counter     = {gd.spaces.projects.menuResourcesCounter}
                        >
                            <NavigationMenu_ProjectsTree
                                showAdd         = {false}
                                space           = {gd.spaces.projects}
                                localSettings   = {this.localSettings}
                            />
                        </NavigationMenuSection>
                    }

                    {!displayResourcesHeader &&
                        <NavigationMenu_ProjectsTree
                            showAdd         = {false}
                            space           = {gd.spaces.projects}
                            localSettings   = {this.localSettings}
                        />
                    }
                </VScroll>
            </div>
        )
    }
}
